<div class="graph-slider">
  <div class="label-section">
    <span>{{label}}&nbsp;</span>
    <span class="value">
      {{currency}}{{selectedMin}}{{magnitude}} - {{currency}}{{selectedMax}}{{magnitude}}
    </span>
  </div>
  <div
    class="chart-container"
  >
    <highcharts-chart 
      *ngIf="chartOptions"
      [Highcharts]="Highcharts" 
      [options]="chartOptions"
      [(update)]="updateFlag">
    </highcharts-chart>
  </div>
  

  <div class="slider-section">
    <app-pharma-slider-filter
      [showLabel]="false"
      [min]="min"
      [max]="max"
      [step]="step"
      [selectedMin]="selectedMin"
      [selectedMax]="selectedMax"
      [magnitude]="magnitude"
      [currency]="currency"
      [isDisabled]="false"
      [valueFormatter]="amountFormatter"
      (onSelectionChange)="onMinMaxChange($event)"
      (onInstantMinMaxChange)="onInstantMinMaxChange($event)"
    ></app-pharma-slider-filter>
  </div>
  <!-- Range slider placed below the chart -->
  <!-- <div style="margin-top: -60px; padding-bottom: 20px;">
    <div class="slider-section">
        <mat-slider [min]="min" [max]="max">
        <input
            matSliderStartThumb
            [ngModel]="selectedMin"
            (dragEnd)="onMinValueChange($event)"
        >
        <input
            matSliderEndThumb
            [ngModel]="selectedMax"
            (dragEnd)="onMaxValueChange($event)"
        >
        </mat-slider>
    </div>
        
    <div>Selected X Range: {{selectedMin}} - {{selectedMax}}</div>
  </div> -->
</div>